import { Box, Collapse, Grid, Stack, Typography } from '@mui/material';
import React, { useState } from 'react';
import { useFormContext } from 'react-hook-form';
import FormCheckbox from '../../../shared/FormCheckbox';
import { Contractor } from '../../../types/contractor';

const ContractorJobPolicies = ({
    contractor,
    isRecurring,
}: {
    contractor: Contractor;
    isRecurring?: boolean;
}) => {
    const {
        control,
        formState: { errors },
    } = useFormContext();

    const [showDetails, setShowDetails] = useState<boolean>(false);

    return (
        <Box
            role='group'
            aria-label={`${contractor?.name}'s Cancellation Policy`}
        >
            <Stack>
                <Typography
                    sx={{
                        fontWeight: 'bold',
                        pb: 0.5,
                    }}
                >
                    {contractor?.name}'s Policies
                </Typography>
                <Typography variant='caption' fontWeight={550} gutterBottom>
                    Please accept the cancellation policy to continue
                </Typography>
            </Stack>
            <Grid
                sx={{
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center',
                }}
            >
                <Box display='flex' alignItems='center' sx={{ m: 0 }}>
                    <FormCheckbox
                        name={`policy.checked`}
                        control={control}
                        sx={{ p: 0, m: 0 }}
                    />
                    <Typography variant='caption' fontWeight={550}>
                        I have read and agree to the{' '}
                        <Box
                            component='span'
                            onClick={() => setShowDetails(!showDetails)}
                            sx={{
                                color: 'primary.main',
                                textDecoration: 'underline',
                                cursor: 'pointer',
                            }}
                        >
                            Cancellation Policy
                        </Box>
                        .
                    </Typography>
                </Box>
            </Grid>

            {!!errors.policy && (
                <Typography variant='caption' color='error' sx={{ mt: 0.5 }}>
                    Please accept the cancellation policy to continue
                </Typography>
            )}

            <Collapse in={showDetails}>
                <Box
                    sx={{
                        display: 'flex',
                        flexDirection: 'column',
                    }}
                >
                    {isRecurring ? (
                        <>
                            <Typography variant='caption' fontWeight={550}>
                                For recurring jobs, the applicable cancellation
                                policy is the contractor’s policy at the time
                                each job occurs.
                            </Typography>
                            {contractor?.cancellationPolicy && (
                                <Typography
                                    variant='caption'
                                    fontWeight={550}
                                    whiteSpace='pre-wrap'
                                    sx={{ mt: 1 }}
                                >
                                    <strong>
                                        Current cancellation policy:
                                    </strong>{' '}
                                    {contractor?.cancellationPolicy}
                                </Typography>
                            )}
                        </>
                    ) : (
                        <Typography
                            variant='caption'
                            fontWeight={550}
                            whiteSpace='pre-wrap'
                        >
                            {contractor?.cancellationPolicy}
                        </Typography>
                    )}
                </Box>
            </Collapse>
        </Box>
    );
};

export default ContractorJobPolicies;
